import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { map } from "lodash";
import Select from "react-select";
import InputMask from "react-input-mask";

import Config from "config";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Table,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import TableComponent from "components/Common/TableComponent";
import OperationList from "components/Common/OperationListHm";
import DocumentHm from "components/Common/DocumentPmeHm";
import DocumentFusionHm from "components/Common/DocumentFusionHm";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import SectionCard from "components/Common/SectionCard";
import SouscriptionFinaliseesListHm from "components/Common/SouscriptionFinaliseesListHm";
import InvestissementListHm from "components/Common/InvestissementListHm";

const investissEdit = () => {
  const api = Config.backOffice.apiName;
  const backUrl = Config.backOffice.url;
  let { id } = useParams();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem("auth_token");
  const navigate = useNavigate();
  const [modal, setModal] = useState(false);
  const [wait, setWait] = useState(1000);
  const toggleModal = () => setModal(!modal);
  const [investData, setInvestData] = useState([]);
  const colStyle = { width: "10em", whiteSpace: "nowrap" };
  const tableaustyles = {
    background: "#3c88c8",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  //meta title
  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Investissements | New";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    const navStyleClient = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
      textAlign: "left",
    };

    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            onClick={() => handleTabClick("details")}
          >
            {!loading ? (
              "Détails investissements"
            ) : (
              <span
                className="placeholder col-3"
                style={{ height: "1em" }}
              ></span>
            )}
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  /*************************   PME  *******************************/
  const [pme, setPmeData] = useState({ data: [] });
  const [selectedPme, setSelectedPme] = useState("");
  const handlePmeChange = (e) => {
    setSelectedPme(e);
  };
  const getPme = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/pmes`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPmeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmeOptions = () => {
    return [
      {
        options: pme.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PME *******************************/
  /*************************   Classe immobilisation  *******************************/
  const [classe, setClasseData] = useState({ data: [] });
  const [selectedClasse, setSelectedClasse] = useState("");
  const handleClasseChange = (e) => {
    setSelectedClasse(e);
  };
  const getClasse = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/classe_immobilisations`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setClasseData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderClasseOptions = () => {
    return [
      {
        options: classe.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Classe *******************************/
  /*************************   Tranche  *******************************/
  const [tranche, setTrancheData] = useState({ data: [] });
  const [selectedTranche, setSelectedTranche] = useState("");
  const handleTrancheChange = (e) => {
    setSelectedTranche(e);
  };
  const getTranche = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/tranchs?${id}&pme_id=${
          selectedPme?.value || ""
        }&tranch_id=${selectedTranche?.value || ""}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setTrancheData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTrancheOptions = () => {
    return [
      {
        options: tranche.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Tranche *******************************/
  /*************************   Code  *******************************/
  const [code, setCodeData] = useState({ data: [] });
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e);
  };
  const getCode = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/codes_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setCodeData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderCodeOptions = () => {
    return [
      {
        options: code.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Code *******************************/
  /*************************   Direction  *******************************/
  const [direction, setDirectionData] = useState({ data: [] });
  const [selectedDirection, setSelectedDirection] = useState("");
  const handleDirectionChange = (e) => {
    setSelectedDirection(e);
  };
  const getDirection = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires3`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setDirectionData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderDirectionOptions = () => {
    return [
      {
        options: direction.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Direction *******************************/
  /****Numéro *****/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /******End Numéro */
  /****designation Courte *****/
  const [selectedDesignationCourte, setSelectedDesignationCourte] =
    useState("");
  const handleDesignationCourteChange = (e) => {
    setSelectedDesignationCourte(e.target.value);
  };
  /******End designation Courte */
  /****designation Op *****/
  const [selectedDesignationOp, setSelectedDesignationOp] = useState("");
  const handleDesignationOpChange = (e) => {
    setSelectedDesignationOp(e.target.value);
  };
  /******End designation Op */
  /****Honoraire 1 *****/
  const [selectedHonoraire1, setSelectedHonoraire1] = useState("");
  const handleHonoraire1Change = (e) => {
    setSelectedHonoraire1(e.target.value);
  };
  /******End Honoraire 1 */
  /****Honoraire 2 *****/
  const [selectedHonoraire2, setSelectedHonoraire2] = useState("");
  const handleHonoraire2Change = (e) => {
    setSelectedHonoraire2(e.target.value);
  };
  /******End Honoraire 2 */
  /****Honoraire 3 *****/
  const [selectedHonoraire3, setSelectedHonoraire3] = useState("");
  const handleHonoraire3Change = (e) => {
    setSelectedHonoraire3(e.target.value);
  };
  /******End Honoraire 3 */
  /****Taux loyer *****/
  const [selectedTauxLoyer, setSelectedTauxLoyer] = useState("");
  const handleTauxLoyerChange = (e) => {
    setSelectedTauxLoyer(e.target.value);
  };
  /******End Taux Loyer */
  /****Taux service *****/
  const [selectedTauxService, setSelectedTauxService] = useState("");
  const handleTauxServiceChange = (e) => {
    setSelectedTauxService(e.target.value);
  };
  /******End Taux Loyer */
  /*************************   Statut  *******************************/
  const [statut, setStatutData] = useState({ data: [] });
  const [selectedStatut, setSelectedStatut] = useState("");
  const handleStatutChange = (e) => {
    setSelectedStatut(e);
  };
  const getStatut = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/statuts_investissements`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setStatutData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderStatutOptions = () => {
    return [
      {
        options: statut.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END Statut *******************************/
  /*************************   PartenaireIndu  *******************************/
  const [partenaireIndu, setPartenaireInduData] = useState({ data: [] });
  const [selectedPartenaireIndu, setSelectedPartenaireIndu] = useState("");
  const handlePartenaireInduChange = (e) => {
    setSelectedPartenaireIndu(e);
  };
  const getPartenaireIndu = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires3 `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setPartenaireInduData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireInduOptions = () => {
    return [
      {
        options: partenaireIndu.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END PartenaireIndu *******************************/
  // Exploitant
  const [exploitant, setExploitantData] = useState({ data: [] });
  const [selectedExploitant, setSelectedExploitant] = useState();
  const handleExploitantChange = (e) => {
    setSelectedExploitant(e);
  };
  const getExploitant = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investissements/partenaires2 `, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pme) => {
          setExploitantData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderExploitantOptions = () => {
    return [
      {
        options: exploitant.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // Section
  const [selectedSection, setSelectedSection] = useState("");
  const handleSectionChange = (e) => {
    setSelectedSection(e.target.value);
  };

  // N° cadastre
  const [selectedCadastre, setSelectedCadastre] = useState("");
  const handleCadastreChange = (e) => {
    setSelectedCadastre(e.target.value);
  };

  // Contenance
  const [selectedContenance, setSelectedContenance] = useState("");
  const handleContenanceChange = (e) => {
    setSelectedContenance(e.target.value);
  };
  // Nature
  const [selectedNature, setSelectedNature] = useState("");
  const handleNatureChange = (e) => {
    setSelectedNature(e.target.value);
  };

  // Lieu-dit
  const [selectedLieuDit, setSelectedLieuDit] = useState("");
  const handleLieuDitChange = (e) => {
    setSelectedLieuDit(e.target.value);
  };

  // Adresse
  const [selectedAdresse, setSelectedAdresse] = useState("");
  const handleAdresseChange = (e) => {
    setSelectedAdresse(e.target.value);
  };

  // Code postal
  const [selectedCodePostal, setSelectedCodePostal] = useState("");
  const handleCodePostalChange = (e) => {
    setSelectedCodePostal(e.target.value);
  };

  // Commune
  const [selectedCommune, setSelectedCommune] = useState("");
  const handleCommuneChange = (e) => {
    setSelectedCommune(e.target.value);
  };

  // Date PV livraison
  const [selectedDateLivraison, setSelectedDateLivraison] = useState("");
  const handleDateLivraisonChange = (e) => {
    setSelectedDateLivraison(e.target.value);
  };
  // Date obtention
  const [selectedDateObtention, setSelectedDateObtention] = useState("");
  const handleDateObtentionChange = (e) => {
    setSelectedDateObtention(e.target.value);
  };
  // Date protocol
  const [selectedDateProtocol, setSelectedDateProtocol] = useState("");
  const handleDateProtocleChange = (e) => {
    setSelectedDateProtocol(e.target.value);
  };

  // Montant (€)
  const [selectedMontant, setSelectedMontant] = useState("");
  const handleMontantChange = (e) => {
    setSelectedMontant(e.target.value);
  };

  // Prix unitaire (€)
  const [selectedPrixUnitaire, setSelectedPrixUnitaire] = useState("");
  const handlePrixUnitaireChange = (e) => {
    setSelectedPrixUnitaire(e.target.value);
  };

  // % rétrocession exploitant
  const [selectedPourcentageRetro, setSelectedPourcentageRetro] = useState("");
  const handlePourcentageRetroChange = (e) => {
    setSelectedPourcentageRetro(e.target.value);
  };

  // Rétrocession exploitant (€)
  const [selectedRetroExploitant, setSelectedRetroExploitant] = useState("");
  const handleRetroExploitantChange = (e) => {
    setSelectedRetroExploitant(e.target.value);
  };
  // Durée amortissement (mois)
  const [selectedDureeAmortissement, setSelectedDureeAmortissement] =
    useState("");
  const handleDureeAmortissementChange = (e) => {
    setSelectedDureeAmortissement(e.target.value);
  };

  // Agrément

  const [selectedAgrement, setSelectedAgrement] = useState();
  const handleAgrementChange = (e) => {
    setSelectedAgrement(e);
  };

  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  // Subvention
  const [selectedSubvention, setSelectedSubvention] = useState();
  const handleSubventionChange = (e) => {
    setSelectedSubvention(e);
  };
  // Subvention(€)
  const [selectedSubvention2, setSelectedSubvention2] = useState("");
  const handleSubvention2Change = (e) => {
    setSelectedSubvention2(e.target.value);
  };
  // PartieVersante
  const [partieVersante, setPartieVersanteData] = useState({ data: [] });
  const [selectedPartieVersante, setSelectedPartieVersante] = useState();
  const handlePartieVersanteChange = (e) => {
    setSelectedPartieVersante(e);
  };
  const getPartie = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/provenance_subventions `,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pme) => {
          setPartieVersanteData(pme);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartieOptions = () => {
    return [
      {
        options: partieVersante.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  // Base éligible (€)
  const [selectedBaseEligible, setSelectedBaseEligible] = useState("");
  const handleBaseEligibleChange = (e) => {
    setSelectedBaseEligible(e.target.value);
  };
  // % réduction impôt
  const [
    selectedPourcentageReductionImpot,
    setSelectedPourcentageReductionImpot,
  ] = useState("");
  const handlePourcentageReductionImpotChange = (e) => {
    setSelectedPourcentageReductionImpot(e.target.value);
  };
  // Réduction impôt (€)
  const [selectedReductionImpot, setSelectedReductionImpot] = useState("");
  const handleReductionImpotChange = (e) => {
    setSelectedReductionImpot(e.target.value);
  };
  /******************************* HMF Loyer *******************************************/
  const [formLoyer, setFormLoyer] = useState([
    {
      index: 1,
      id: null,
      date: null,
      num_facture: null,
      montant_ht: null,
    },
  ]);

  const onAddFormLoyer = () => {
    const modifiedDonneesLoyer = [...formLoyer];
    console.log(modifiedDonneesLoyer);
    modifiedDonneesLoyer.push({
      index: modifiedDonneesLoyer.length + 1,
      id: null,
      date: null,
      num_facture: null,
      montant_ht: null,
    });
    console.log(modifiedDonneesLoyer);
    setFormLoyer(modifiedDonneesLoyer);
  };

  const onDeleteFormLoyer = (id) => {
    var modifiedDonneesLoyer = [...formLoyer];
    modifiedDonneesLoyer = modifiedDonneesLoyer.filter(
      (x) => x["index"] !== id
    );
    setFormLoyer(modifiedDonneesLoyer);
  };
  const handleInputLoyerChange = (index, field, value) => {
    const modifiedDonneesLoyer = formLoyer.map((donnesLoyer) => {
      if (donnesLoyer.index === index) {
        return {
          ...donnesLoyer,
          [field]: value,
        };
      }
      return donnesLoyer;
    });

    setFormLoyer(modifiedDonneesLoyer);
    console.log(modifiedDonneesLoyer);
  };
  /******************************* END HMF DonneesLoyer *******************************************/
  /******************************* HMF Amortissements *******************************************/
  const [formAmortissements, setFormAmortissements] = useState([
    {
      index: 1,
      id: null,
      date: null,
      montant: null,
    },
  ]);

  const onAddFormAmortissements = () => {
    const modifiedAmortissements = [...formAmortissements];
    console.log(modifiedAmortissements);
    modifiedAmortissements.push({
      index: modifiedAmortissements.length + 1,
      id: null,
      date: null,
      montant: null,
    });
    console.log(modifiedAmortissements);
    setFormAmortissements(modifiedAmortissements);
  };

  const onDeleteFormAmortissements = (id) => {
    var modifiedAmortissements = [...formAmortissements];
    modifiedAmortissements = modifiedAmortissements.filter(
      (x) => x["index"] !== id
    );
    setFormAmortissements(modifiedAmortissements);
  };
  const handleInputAmortissementsChange = (index, field, value) => {
    const modifiedAmortissements = formAmortissements.map(
      (donnesAmortissements) => {
        if (donnesAmortissements.index === index) {
          return {
            ...donnesAmortissements,
            [field]: value,
          };
        }
        return donnesAmortissements;
      }
    );

    setFormAmortissements(modifiedAmortissements);
  };
  /******************************* END HMF Amortissements *******************************************/
  //****SHOW */
  const [showField, setShowFied] = useState("");
  const getShow = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investissements/show_fields?pme_id=${
          selectedPme?.value || ""
        }&statuts_investissments=${selectedStatut?.value || ""}&subvention2=${
          selectedSubvention?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((reservation) => {
          setShowFied(reservation);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investissements`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            investissement: {
              numero: selectedNumero,
              pme_id: selectedPme?.value || "",
              section: selectedSection,
              n_cadastre: selectedCadastre,
              contenance: selectedContenance,
              nature: selectedNature,
              n_protocole: "",
              lieudit: selectedLieuDit,
              code_postal: selectedCodePostal,
              commune: selectedCommune,
              date_protocole: selectedDateProtocol,
              montant: selectedMontant,
              date_pv_livraison: selectedDateLivraison,
              pourc_retrocession_exploitant: selectedPourcentageRetro,
              agrement: selectedAgrement?.value || "",
              subvention: selectedSubvention2,
              date_obtention_subvention: selectedDateObtention,
              base_eligible_investissement: selectedBaseEligible,
              taux_reduction_impot: selectedPourcentageReductionImpot,
              reduction_impot: selectedReductionImpot,
              duree_amortissement: selectedDureeAmortissement,
              description: selectedDesignationOp,
              tranch_id: selectedTranche?.value || "",
              codes_investissement_id: selectedCode?.value || "",
              statuts_investissement_id: selectedStatut?.value || "",
              partenaire2_id: selectedExploitant?.value || "",
              partenaire3_id: selectedPartenaireIndu?.value || "",
              provenance_subvention_id: selectedPartieVersante?.value || "",
              subvention2: selectedSubvention?.value || "",
              adresse: selectedAdresse,
              retrocession: selectedRetroExploitant,
              prix_unitaire: selectedPrixUnitaire,
              classe_immobilisation_id: selectedClasse?.value || "",
              designation_courte: selectedDesignationCourte,
              taux_loyer: selectedTauxLoyer,
              taux_service: selectedTauxService,
              honoraire_1: selectedHonoraire1,
              honoraire_2: selectedHonoraire2,
              honoraire_3: selectedHonoraire3,
            },
            hmf_loyers: formLoyer.map((obj) => {
              delete obj.index;
              return obj;
            }),

            hmf_amortissements: formAmortissements.map((obj) => {
              delete obj.index;
              return obj;
            }),
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.investissement_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.investissement_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
    // }
  };

  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
    }
  }, [wait]);
  useEffect(() => {
    if (!loading) {
      getPme();
      getClasse();
      getTranche();
      getCode();
      getDirection();
      getStatut();
      getPartenaireIndu();
      getExploitant();
      getPartie();
      getShow();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getTranche();
    }
  }, [selectedPme, selectedTranche]);
  useEffect(() => {
    if (!loading) {
      getShow();
    }
  }, [selectedStatut, selectedSubvention, selectedPme]);
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      {!loading ? (
                        <>
                          <Link
                            to={`${backUrl}/investissements`}
                            style={{
                              color: "#3c88c8",
                              textDecoration: "underline !important",
                            }}
                          >
                            Investissements
                          </Link>{" "}
                        </>
                      ) : (
                        <span
                          className="placeholder col-3"
                          style={{ height: "1em" }}
                        ></span>
                      )}
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        <>New</>
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          >
                            N
                          </span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <button
                        className="btn btn-sm btn-info"
                        onClick={handleSubmit}
                      >
                        <i className="bx bx-send"></i> Valider
                      </button>
                      &nbsp; &nbsp;
                      <Link
                        to="#"
                        onClick={() => navigate(-1)}
                        className="btn btn-sm btn-soft-secondary "
                        style={{ width: "88.43px" }}
                      >
                        <i className="bx bx-arrow-back"></i> Annuler
                      </Link>
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Caractéristiques de l'investissement
                                </CardTitle>
                                <CardBody>
                                  <Row className="mb-3">
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            PME:
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedPme}
                                          onChange={handlePmeChange}
                                          options={renderPmeOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Classe immobilisation:
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedClasse}
                                          onChange={handleClasseChange}
                                          options={renderClasseOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Tranche :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedTranche}
                                          onChange={handleTrancheChange}
                                          options={renderTrancheOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Direction produit :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedDirection}
                                          onChange={handleDirectionChange}
                                          options={renderDirectionOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Code secteur :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedCode}
                                          onChange={handleCodeChange}
                                          options={renderCodeOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Statut :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedStatut}
                                          onChange={handleStatutChange}
                                          options={renderStatutOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Numéro :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedNumero}
                                          required
                                          onChange={handleNumeroChange}
                                        />
                                      </Col>
                                    </Row>
                                    {showField?.displayed_fields?.includes(
                                      "date_protocole"
                                    ) ? (
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: "10px",
                                              }}
                                            >
                                              Date protocole :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <InputMask
                                            mask="99/99/9999"
                                            value={selectedDateProtocol}
                                            className="form-control input-color"
                                            onChange={(dateString) => {
                                              setSelectedDateProtocol(
                                                dateString.target.value
                                              );
                                            }}
                                          />
                                        </Col>
                                      </Row>
                                    ) : null}
                                  </Row>
                                </CardBody>
                              </Card>

                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Description
                                </CardTitle>
                                <CardBody>
                                  <Row className="mb-3">
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Désignation courte :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={
                                            selectedDesignationCourte
                                          }
                                          required
                                          onChange={
                                            handleDesignationCourteChange
                                          }
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "wrap",
                                            }}
                                          >
                                            Désignation de l'opération :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedDesignationOp}
                                          required
                                          onChange={handleDesignationOpChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "wrap",
                                            }}
                                          >
                                            Partenaires industriels:
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <Select
                                          defaultValue={selectedPartenaireIndu}
                                          onChange={handlePartenaireInduChange}
                                          options={renderPartenaireInduOptions()}
                                          isClearable={true}
                                          className="select2"
                                        />
                                      </Col>
                                    </Row>
                                  </Row>
                                </CardBody>
                              </Card>

                              <Card className="mb-4">
                                <CardTitle
                                  tag="h5"
                                  style={{ paddingLeft: "10px" }}
                                >
                                  Honoraires
                                </CardTitle>
                                <CardBody>
                                  <Row className="mb-3">
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Honoraire 1 :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedHonoraire1}
                                          required
                                          onChange={handleHonoraire1Change}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Honoraire 2 :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedHonoraire2}
                                          required
                                          onChange={handleHonoraire2Change}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Honoraire 3 :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedHonoraire3}
                                          required
                                          onChange={handleHonoraire3Change}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Taux loyer :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedTauxLoyer}
                                          required
                                          onChange={handleTauxLoyerChange}
                                        />
                                      </Col>
                                    </Row>
                                    <Row className="mb-3">
                                      <Col
                                        xs={12}
                                        md={12}
                                        lg={4}
                                        style={colStyle}
                                      >
                                        <i
                                          style={{
                                            color: "#9d9c9c",
                                          }}
                                        >
                                          <span
                                            style={{
                                              display: "inline-block",
                                              width: "8em",
                                              whiteSpace: "nowrap",
                                              paddingTop: "10px",
                                            }}
                                          >
                                            Taux service :
                                          </span>
                                        </i>
                                      </Col>
                                      <Col className="col-8">
                                        <input
                                          className="form-control"
                                          defaultValue={selectedTauxService}
                                          required
                                          onChange={handleTauxServiceChange}
                                        />
                                      </Col>
                                    </Row>
                                  </Row>
                                </CardBody>
                              </Card>

                              <Col sm="12">
                                <Row className="mb-3">
                                  <Card className="mb-4">
                                    <CardTitle tag="h5">Loyers</CardTitle>
                                    <CardBody>
                                      <Col sm="12">
                                        <div className="table-responsive">
                                          <table
                                            className="table table-bordered rounded-3 overflow-hidden"
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  className=""
                                                  style={tableaustyles}
                                                >
                                                  Date
                                                </th>
                                                <th
                                                  className=""
                                                  style={tableaustyles}
                                                >
                                                  N° facture
                                                </th>
                                                <th
                                                  className=""
                                                  style={tableaustyles}
                                                >
                                                  Montant HT
                                                </th>

                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#3c88c8",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    width: "1%",
                                                  }}
                                                  key="Del"
                                                ></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formLoyer.map((rowData) => (
                                                <tr key={rowData.index}>
                                                  {Object.entries(rowData).map(
                                                    ([key, value]) =>
                                                      key !== "id" &&
                                                      key !== "index" ? (
                                                        <td key={key}>
                                                          {key === "date" ? (
                                                            <InputMask
                                                              name={key}
                                                              mask="99/99/9999"
                                                              value={value}
                                                              className="form-control form-control-sm input-color"
                                                              onChange={(e) =>
                                                                handleInputLoyerChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "montant_ht" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputLoyerChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "num_facture" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputLoyerChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <span>{value}</span>
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td
                                                          className="d-none"
                                                          key={key}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            value={value}
                                                          />
                                                        </td>
                                                      )
                                                  )}
                                                  <td>
                                                    <i
                                                      className="bx bx-trash"
                                                      style={{
                                                        fontSize: "20px",
                                                        paddingTop: "5px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        onDeleteFormLoyer(
                                                          rowData.index
                                                        )
                                                      }
                                                    ></i>
                                                  </td>
                                                </tr>
                                              ))}
                                              <tr>
                                                <td colSpan="9">
                                                  <input
                                                    type="button"
                                                    style={tableaustyles}
                                                    className="btn btn-info mt-3 mt-lg-0"
                                                    value="Ajouter"
                                                    onClick={onAddFormLoyer}
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </Col>
                                    </CardBody>
                                  </Card>
                                </Row>
                              </Col>

                              <Col sm="12">
                                <Row className="mb-3">
                                  <Card className="mb-4">
                                    <CardTitle tag="h5">
                                      Tableau des amortissements
                                    </CardTitle>
                                    <CardBody>
                                      <Col sm="12">
                                        <div className="table-responsive">
                                          <table
                                            className="table table-bordered rounded-3 overflow-hidden"
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  className=""
                                                  style={tableaustyles}
                                                >
                                                  Date
                                                </th>
                                                <th
                                                  className=""
                                                  style={tableaustyles}
                                                >
                                                  Montant
                                                </th>
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#3c88c8",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    width: "1%",
                                                  }}
                                                  key="Del"
                                                ></th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formAmortissements.map(
                                                (rowData) => (
                                                  <tr key={rowData.index}>
                                                    {Object.entries(
                                                      rowData
                                                    ).map(([key, value]) =>
                                                      key !== "id" &&
                                                      key !== "index" ? (
                                                        <td key={key}>
                                                          {key === "date" ? (
                                                            <InputMask
                                                              name={key}
                                                              mask="99/99/9999"
                                                              value={value}
                                                              className="form-control form-control-sm input-color"
                                                              onChange={(e) =>
                                                                handleInputAmortissementsChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : key ===
                                                            "montant" ? (
                                                            <input
                                                              className="form-control form-control-sm"
                                                              defaultValue={
                                                                value
                                                              }
                                                              name={key}
                                                              onChange={(e) =>
                                                                handleInputAmortissementsChange(
                                                                  rowData.index,
                                                                  e.target.name,
                                                                  e.target.value
                                                                )
                                                              }
                                                            />
                                                          ) : (
                                                            <span>{value}</span>
                                                          )}
                                                        </td>
                                                      ) : (
                                                        <td
                                                          className="d-none"
                                                          key={key}
                                                        >
                                                          <input
                                                            type="hidden"
                                                            value={value}
                                                          />
                                                        </td>
                                                      )
                                                    )}
                                                    <td>
                                                      <i
                                                        className="bx bx-trash"
                                                        style={{
                                                          fontSize: "20px",
                                                          paddingTop: "5px",
                                                          textAlign: "center",
                                                          verticalAlign:
                                                            "middle",
                                                          cursor: "pointer",
                                                        }}
                                                        onClick={() =>
                                                          onDeleteFormAmortissements(
                                                            rowData.index
                                                          )
                                                        }
                                                      ></i>
                                                    </td>
                                                  </tr>
                                                )
                                              )}
                                              <tr>
                                                <td colSpan="9">
                                                  <input
                                                    type="button"
                                                    style={tableaustyles}
                                                    className="btn btn-info mt-3 mt-lg-0"
                                                    value="Ajouter"
                                                    onClick={
                                                      onAddFormAmortissements
                                                    }
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </Col>
                                    </CardBody>
                                  </Card>
                                </Row>
                              </Col>
                            </Col>
                            <Col sm="6">
                              <Row>
                                <Card className="mb-4">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingLeft: "10px" }}
                                  >
                                    Exploitation
                                  </CardTitle>
                                  <CardBody>
                                    <Row className="mb-3">
                                      {showField?.displayed_fields?.includes(
                                        "partenaire2_id"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Exploitant :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <Select
                                              defaultValue={selectedExploitant}
                                              onChange={handleExploitantChange}
                                              options={renderExploitantOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "section"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Section:
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedSection}
                                              required
                                              onChange={handleSectionChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: "10px",
                                              }}
                                            >
                                              Adresse :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <input
                                            className="form-control"
                                            defaultValue={selectedAdresse}
                                            required
                                            onChange={handleAdresseChange}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: "10px",
                                              }}
                                            >
                                              Montant (€):
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <input
                                            className="form-control"
                                            defaultValue={selectedMontant}
                                            required
                                            onChange={handleMontantChange}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: "10px",
                                              }}
                                            >
                                              Prix unitaire (€) :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <input
                                            className="form-control"
                                            defaultValue={selectedPrixUnitaire}
                                            required
                                            onChange={handlePrixUnitaireChange}
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "wrap",
                                              }}
                                            >
                                              Rétrocession exploitant (€) :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <input
                                            className="form-control"
                                            defaultValue={
                                              selectedRetroExploitant
                                            }
                                            required
                                            onChange={
                                              handleRetroExploitantChange
                                            }
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: 10,
                                              }}
                                            >
                                              Subvention :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <Select
                                            defaultValue={selectedSubvention}
                                            onChange={handleSubventionChange}
                                            options={renderOuiNonOptions()}
                                            isClearable={true}
                                            className="select2"
                                          />
                                        </Col>
                                      </Row>
                                      <Row className="mb-3">
                                        <Col
                                          xs={12}
                                          md={12}
                                          lg={4}
                                          style={colStyle}
                                        >
                                          <i
                                            style={{
                                              color: "#9d9c9c",
                                            }}
                                          >
                                            <span
                                              style={{
                                                display: "inline-block",
                                                width: "8em",
                                                whiteSpace: "nowrap",
                                                paddingTop: 10,
                                              }}
                                            >
                                              Partie versante :
                                            </span>
                                          </i>
                                        </Col>
                                        <Col className="col-8">
                                          <Select
                                            defaultValue={
                                              selectedPartieVersante
                                            }
                                            onChange={
                                              handlePartieVersanteChange
                                            }
                                            options={renderPartieOptions()}
                                            isClearable={true}
                                            className="select2"
                                          />
                                        </Col>
                                      </Row>
                                      {showField?.displayed_fields?.includes(
                                        "n_cadastre"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                N° cadastre :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedCadastre}
                                              required
                                              onChange={handleCadastreChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}{" "}
                                      {showField?.displayed_fields?.includes(
                                        "contenance"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Contenance :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedContenance}
                                              required
                                              onChange={handleContenanceChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "nature"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Nature :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedNature}
                                              required
                                              onChange={handleNatureChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "lieudit"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Lieu-dit :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedLieuDit}
                                              required
                                              onChange={handleLieuDitChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "code_postal"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Code postal :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedCodePostal}
                                              required
                                              onChange={handleCodePostalChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "commune"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Commune :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedCommune}
                                              required
                                              onChange={handleCommuneChange}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "date_pv_livraison"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Date PV livraison :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <InputMask
                                              mask="99/99/9999"
                                              value={selectedDateLivraison}
                                              className="form-control input-color"
                                              onChange={(dateString) => {
                                                setSelectedDateLivraison(
                                                  dateString.target.value
                                                );
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "date_obtention_subvention"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "wrap",
                                                }}
                                              >
                                                Date obtention subvention :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <InputMask
                                              mask="99/99/9999"
                                              value={selectedDateObtention}
                                              className="form-control input-color"
                                              onChange={(dateString) => {
                                                setSelectedDateObtention(
                                                  dateString.target.value
                                                );
                                              }}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "pourc_retrocession_exploitant"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "wrap",
                                                }}
                                              >
                                                % rétrocession exploitant :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={
                                                selectedPourcentageRetro
                                              }
                                              required
                                              onChange={
                                                handlePourcentageRetroChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "duree_amortissement"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "wrap",
                                                }}
                                              >
                                                Durée amortissement (mois) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={
                                                selectedDureeAmortissement
                                              }
                                              required
                                              onChange={
                                                handleDureeAmortissementChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "agrement"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: 10,
                                                }}
                                              >
                                                Agrément :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <Select
                                              defaultValue={selectedAgrement}
                                              onChange={handleAgrementChange}
                                              options={renderOuiNonOptions()}
                                              isClearable={true}
                                              className="select2"
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "subvention"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: 10,
                                                }}
                                              >
                                                Subventions (€) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={selectedSubvention2}
                                              required
                                              onChange={handleSubvention2Change}
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "base_eligible_investissement"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Base éligible (€) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={
                                                selectedBaseEligible
                                              }
                                              required
                                              onChange={
                                                handleBaseEligibleChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "reduction_impot"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                Réduction impôt (€) :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={
                                                selectedReductionImpot
                                              }
                                              required
                                              onChange={
                                                handleReductionImpotChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                      {showField?.displayed_fields?.includes(
                                        "taux_reduction_impot"
                                      ) ? (
                                        <Row className="mb-3">
                                          <Col
                                            xs={12}
                                            md={12}
                                            lg={4}
                                            style={colStyle}
                                          >
                                            <i
                                              style={{
                                                color: "#9d9c9c",
                                              }}
                                            >
                                              <span
                                                style={{
                                                  display: "inline-block",
                                                  width: "8em",
                                                  whiteSpace: "nowrap",
                                                  paddingTop: "10px",
                                                }}
                                              >
                                                % réduction impôt :
                                              </span>
                                            </i>
                                          </Col>
                                          <Col className="col-8">
                                            <input
                                              className="form-control"
                                              defaultValue={
                                                selectedPourcentageReductionImpot
                                              }
                                              required
                                              onChange={
                                                handlePourcentageReductionImpotChange
                                              }
                                            />
                                          </Col>
                                        </Row>
                                      ) : null}
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Row>
                            </Col>{" "}
                            <Col sm="12">{/*  */}</Col>
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default investissEdit;
